import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mv-cancel-button',
  templateUrl: './cancel-button.component.html',
  styleUrls: ['./cancel-button.component.scss']
})
export class CancelButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
